import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-height" }

import { onBeforeUnmount, onMounted, ref} from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DragPane',
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const props = __props
  const isDragging = ref(false);
  const cursorPos = ref([0, 0]);
  const el = ref < HTMLDivElement | null > (null);

  onMounted(() => {
    window.addEventListener("mouseup", onMouseUp);
  })
  onBeforeUnmount(() => {
    window.removeEventListener("mouseup", onMouseUp);
  })

  function onMouseDown(ev: MouseEvent) {
    cursorPos.value = [ev.pageX, ev.pageY];
    isDragging.value = true;

    window.addEventListener("mousemove", onMouseHold);
  }

  function onMouseHold(ev: MouseEvent) {
    ev.preventDefault();

    requestAnimationFrame(() => {
      const delta = [
        ev.pageX - cursorPos.value[0],
        ev.pageY - cursorPos.value[1],
      ];

      cursorPos.value = [ev.pageX, ev.pageY];

      if (!el.value) return;
      el.value.scrollBy({
        left: -delta[0],
        top: -delta[1],
      });
    });
  }

  function onMouseUp(ev: MouseEvent) {
    window.removeEventListener("mousemove", onMouseHold);
    isDragging.value = false;
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      ref_key: "el",
      ref: el,
      style: _normalizeStyle([{"width":"100%","height":"100%","overflow":"auto","display":"flex"}, {
        cursor: isDragging.value ? 'grabbing' : 'grab',
        scrollSnapType: isDragging.value ? '' : '',
      }]),
      onMousedown: _withModifiers(onMouseDown, ["prevent","stop"]),
      onMouseup: _withModifiers(onMouseUp, ["prevent"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 36)
  ]))
}
}

})